import React, { useMemo, useState } from 'react';
import { View, TouchableOpacity, ScrollView } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';

import useFormSubmit from '../../../../hooks/useFormSubmit';
import BottomSheet from '../../../../components/BottomSheet';
import useActiveAdminCommunity from '../../../../hooks/useActiveAdminCommunity';
import StaffRolePicker from './StaffRolePicker';


export default function NewAdminModal({ onRequestClose, onUserCreated, visible }) {
  const { communityId } = useActiveAdminCommunity()
  const { control, handleSubmit } = useForm();
  const [roles, setRoles] = useState<string[]>([]);

  const snapPoints = useMemo(() => ['15%', 520], []);

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onUserCreated,
    onError: (error) => { },
    successToastMessage: "Agregado al equipo",
    endpoint: `/communities/${communityId}/staff`,
  })

  return (
    <BottomSheet
      height={720}
      visible={visible}
      onRequestClose={onRequestClose}
    >
      <ScrollView style={tw`px-5`}>
        <View style={tw`row justify-between mb-4 mt-5`}>
          <Text style={tw`text-lg font-600 text-secondary`}>Agregar al equipo</Text>

          <TouchableOpacity
            style={tw`items-center justify-center mr-2`}
            onPress={onRequestClose}
          >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>

        <View style={tw`mb-1`}>
          <Text style={tw`text-gray-500 mb-1`}>Nombre</Text>
          <Input
            control={control}
            name='name'
            placeholder='Ej. Juan Pérez'
            style={{ subcontainer: tw`rounded-2xl bg-gray-100` }}
            maxLength={100}
            rules={{ required: true }}
          />
        </View>

        <View style={tw`mb-1`}>
          <Text style={tw`text-gray-500 mb-1`}>Correo electrónico</Text>
          <Input
            control={control}
            name='email'
            placeholder='correo@ejemplo.com'
            style={{ subcontainer: tw`rounded-2xl bg-gray-100` }}
            keyboardType="email-address"
            rules={{ required: true }}
          />
        </View>

        <View style={tw`mb-1`}>
          <Text style={tw`text-gray-500 mb-1`}>Teléfono</Text>
          <Input
            control={control}
            name='phone_number'
            placeholder='10 dígitos'
            style={{ subcontainer: tw`rounded-2xl bg-gray-100` }}
            maxLength={10}
            keyboardType="phone-pad"
            rules={{ required: true }}
          />
        </View>

        <View style={tw`mb-4`}>
          <Text style={tw`text-gray-500 mb-1`}>Roles</Text>
          <StaffRolePicker value={roles} onChange={setRoles} disabled={isSubmitting} />
        </View>

        <IconButton
          icon='check'
          title={isSubmitting ? "Agregando..." : "Agregar"}
          disabled={isSubmitting || roles.length === 0}
          style={tw`w-full py-3 mb-6`}
          onPress={handleSubmit(data => submitForm({ ...data, roles }))}
        />
      </ScrollView>
    </BottomSheet>
  );
}
